import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
  },
  mutations: {
    setIsLoading(state, value) {
      state.isLoading = value;
    }
  },
  getters: {
    isLoading: ({ isLoading }) => isLoading,
  },
  actions: {
  },
  modules: {
  }
})
